import { FeatureTrackingHelper } from './feature-tracking-helper';
import { FeatureTracking } from '../offers-tracking-model';
import cloneDeep from 'lodash/cloneDeep';
import { Feature, submitMerge } from '@otto-ec/tracking-bct';

export class ViewTracking {
    constructor(private featureTrackingHelper: FeatureTrackingHelper) {}

    public track() {
        const featureTracking = this.featureTrackingHelper.getFeatureTrackingFromHtml();
        this.sendFeatureTracking(featureTracking);
        this.removeOrderServiceSumFields(featureTracking);
    }

    private sendFeatureTracking(featureTracking: FeatureTracking): void {
        const featureTrackingOutput = this.featureTrackingHelper.generateFeatureTrackingOutput(featureTracking);
        submitMerge({ ot_PageCluster: ['Offerspage'] }, featureTrackingOutput as never as Feature[]); /*                                                                                                                                                                                  */
    }

    private removeOrderServiceSumFields(featureTracking: FeatureTracking) {
        const featureTrackingCopy: FeatureTracking = cloneDeep(featureTracking);
        featureTrackingCopy.offerVariations.forEach(offerVariation => delete offerVariation.labels.order_ServiceSumVariation);
        this.featureTrackingHelper.setFeatureTrackingInHtml(featureTrackingCopy);
    }
}
